import { defineComponent as ee, ref as v, reactive as Y, computed as B, provide as re, onMounted as te, nextTick as oe, openBlock as $, createElementBlock as R, normalizeClass as F, createElementVNode as q, normalizeStyle as ue, renderSlot as H, unref as A, createTextVNode as Z, createCommentVNode as G, Fragment as ie, renderList as se, toDisplayString as M, inject as ae, onUnmounted as ce } from "vue";
const de = ["id"], ve = ["disabled"], fe = ["disabled"], ge = { class: "c-slider-pagination" }, he = ["onClick"], ye = /* @__PURE__ */ ee({
  __name: "SliderTrack",
  props: {
    overflowDirection: {
      validator(W) {
        return ["forwards", "backwards", "both", "none", void 0].includes(
          W
        );
      },
      default() {
        return "none";
      }
    },
    sliderId: {
      type: String,
      required: !0
    },
    grouped: {
      type: Boolean
    },
    snapToGrid: {
      type: Boolean
    },
    dynamicActiveSizing: {
      type: Boolean
    },
    hideButtons: {
      type: Boolean
    },
    threshold: {
      type: Number,
      default: 15
    }
  },
  setup(W, { expose: m }) {
    const u = W, t = v(), d = Y({ left: 0, x: 0, offsetX: 0 }), o = v(0), b = v(0), i = v([]), h = v(null), w = v("none"), k = v(!1), z = v(!1);
    m({
      activeIndex: o,
      totalSlides: B(() => i.value.length),
      currentIndex: B(() => o.value + 1),
      goToCard: E
    });
    const p = B(() => i.value.filter((e) => {
      var s, l;
      return e.getBoundingClientRect().left < ((l = (s = t.value) == null ? void 0 : s.clientWidth) != null ? l : 0);
    }));
    Y({
      cardIds: []
    });
    const T = B(() => i.value.slice(0, (p.value.length - 1) * -1).reduce((n, s, l) => l === 0 ? (n.push(l), n) : (l >= p.value.length && l % p.value.length === 0 && u.grouped && n.push(l), l >= p.value.length && l === i.value.length - 1 && l % p.value.length !== 0 && u.grouped && n.push(l), u.grouped || n.push(l), n), [])), r = B(() => o.value === 0), _ = B(() => o.value === i.value.length - p.value.length);
    re(u.sliderId, o);
    const y = function(e) {
      if (u.grouped === !0)
        return;
      const n = e.target;
      e.preventDefault(), n && (J(n), d.x = e.clientX, document.addEventListener("mousemove", x), document.addEventListener("mouseup", S));
    }, x = function(e) {
      if (!t.value || t.value.id !== h.value)
        return;
      k.value = !0;
      const n = e.clientX - d.x;
      !Q(n) || (b.value = n + d.offsetX);
    }, S = function(e) {
      !t.value || t.value.id !== h.value || (document.removeEventListener("mousemove", x), document.removeEventListener("mouseup", S), K());
    }, L = function(e) {
      k.value && (e.preventDefault(), e.stopPropagation());
    };
    function X(e) {
      return (e == null ? void 0 : e.closest(".c-slider__track")) !== null || (e == null ? void 0 : e.closest(".c-slider")) !== null;
    }
    function D(e, n = 0) {
      return e.reduce(
        (l, c) => Math.abs(c.x - n) < Math.abs(l.x - n) ? c : l,
        {
          x: e[0].x,
          index: e[0].index
        }
      ).index;
    }
    function V() {
      var s;
      if (u.grouped) {
        const l = document.querySelector(".c-slider__track");
        if (!l || !t.value || l.scrollLeft + l.clientWidth > l.scrollWidth)
          return;
        const c = t.value.children, a = Array.from(c).map((f, g) => ({
          x: f.getBoundingClientRect().x,
          index: g
        }));
        o.value = D(a, t.value.clientWidth), (s = t.value) == null || s.scrollTo({
          left: t.value.scrollLeft + t.value.clientWidth,
          behavior: "smooth"
        });
        return;
      }
      const e = o.value;
      e === i.value.length - 1 || !document.querySelector(`#slide-${e}`) || !t.value || (o.value = e + 1, E(o.value));
    }
    function ne() {
      if (u.grouped) {
        if (!document.querySelector(".c-slider__track") || !t.value)
          return;
        const s = t.value.children, l = Array.from(s).map((g, I) => ({
          x: g.getBoundingClientRect().x,
          index: I
        }));
        let c = t.value.clientWidth;
        const a = o.value % (p.value.length + 1);
        if (a !== 0 && a !== p.value.length) {
          const g = o.value, I = [], N = g === i.value.length - 1;
          for (let C = g - (p.value.length - a); N ? C < g : C <= g; C++) {
            const O = document.querySelector(`#slide-${C}`);
            O && I.push(O);
          }
          c = I.map((C) => C.clientWidth).reduce((C, O) => C + O, 0);
        }
        const f = D(l, 0 - c);
        o.value = f, E(o.value);
        return;
      }
      const e = o.value;
      e !== 0 && (o.value = e - 1, E(o.value));
    }
    function E(e) {
      if (!document.querySelector(`#slide-${e}`) || !t.value)
        return;
      let s = 0, l = getComputedStyle(t.value), c = parseInt(l.gap.replace("px", ""));
      if (o.value = e, u.dynamicActiveSizing) {
        for (let a = 0; a < o.value; a++) {
          const f = i.value[a].clientHeight, g = i.value[a + 1].clientHeight;
          if (f > g) {
            s += i.value[a + 1].offsetWidth + c;
            continue;
          } else
            s += i.value[a].offsetWidth + c;
        }
        b.value = s * -1;
      } else
        for (let a = 0; a < o.value; a++)
          s += i.value[a].offsetWidth + c;
      b.value = s * -1;
    }
    const le = function(e) {
      if (u.grouped === !0)
        return;
      const n = e.target;
      !n || (J(n), d.x = e.touches[0].clientX, document.addEventListener("touchmove", U), document.addEventListener("touchend", j));
    }, U = function(e) {
      if (!t.value || t.value.id !== h.value)
        return;
      k.value = !0;
      const n = e.touches[0].clientX - d.x;
      !Q(n) || (b.value = n + d.offsetX);
    }, j = function(e) {
      !t.value || t.value.id !== h.value || (document.removeEventListener("touchmove", U), document.removeEventListener("touchend", j), K());
    }, J = function(e) {
      if (k.value = !1, X(e)) {
        let n = e.closest(".c-slider__track");
        if (!n)
          return;
        h.value = n.id, z.value = !1;
      }
      e.tagName === "A" && (z.value = !0), t.value || (t.value = document.getElementById(u.sliderId)), t.value && (t.value.style.cursor = "grabbing", t.value.style.userSelect = "none", t.value.style.scrollBehavior = "none", t.value.style.transition = "none", d.left = t.value.scrollLeft, d.offsetX = b.value);
    }, K = function() {
      if (!t.value || t.value.id !== h.value)
        return;
      t.value.style.cursor = "grab", t.value.style.removeProperty("user-select"), t.value.style.removeProperty("transition");
      const e = document.querySelector(`#${u.sliderId}.c-slider__track`);
      if (!e)
        return;
      const n = t.value.children, s = window.getComputedStyle(e).getPropertyValue("transform"), c = new DOMMatrix(s).m41;
      let a = -1;
      for (let f = 0; f < n.length; f++) {
        const g = n[f], I = g.offsetLeft, N = I + g.clientWidth;
        let P = 0.9;
        if (w.value == "right" && (P = 0.1), I >= -c) {
          a = f;
          break;
        }
        if (N * P >= -c) {
          a = f;
          break;
        }
        if (f == n.length - 1) {
          a = f;
          break;
        }
      }
      o.value = a, h.value = null, u.snapToGrid && E(o.value);
    }, Q = (e) => (w.value = e > 0 ? "left" : "right", Math.abs(e) > u.threshold);
    return te(() => {
      oe(() => {
        i.value = Array.from(
          document.querySelectorAll(`#${u.sliderId} .c-slider-element`)
        ), t.value = document.getElementById(u.sliderId);
        const e = document.querySelectorAll(
          `#${u.sliderId} .c-slider-element a`
        );
        for (var n = 0; n < e.length; n++)
          e[n].addEventListener("click", L);
        if (u.dynamicActiveSizing && t.value) {
          const s = Math.max(
            ...i.value.reduce((l, c) => (l.push(Number(getComputedStyle(c).height.replace("px", ""))), l), [])
          );
          t.value.style.height = `${s}px`;
        }
      }), window.addEventListener("resize", () => {
        E(o.value);
      });
    }), (e, n) => {
      var s;
      return $(), R("div", {
        class: F(["c-slider", "c-slider--overflow-" + W.overflowDirection])
      }, [
        q("div", {
          class: "c-slider__container",
          onMousedown: y,
          onTouchstart: le
        }, [
          q("ul", {
            id: (s = u.sliderId) != null ? s : "qd-slider-0",
            class: "c-slider__track",
            style: ue({ transform: `translate3d(${b.value}px, 0, 0)` })
          }, [
            H(e.$slots, "default")
          ], 12, de)
        ], 32),
        u.hideButtons ? G("", !0) : ($(), R("button", {
          key: 0,
          class: "c-slider-navigation-button c-slider-backwards-button",
          onClick: ne,
          disabled: A(r)
        }, [
          H(e.$slots, "button-backwards", {}, () => [
            Z("Backwards")
          ])
        ], 8, ve)),
        u.hideButtons ? G("", !0) : ($(), R("button", {
          key: 1,
          class: "c-slider-navigation-button c-slider-forwards-button",
          onClick: V,
          disabled: A(_)
        }, [
          H(e.$slots, "button-forwards", {}, () => [
            Z("Forwards")
          ])
        ], 8, fe)),
        q("ul", ge, [
          H(e.$slots, "pagniation", { activeIndex: o.value }, () => [
            ($(!0), R(ie, null, se(A(T), (l) => ($(), R("li", { key: l }, [
              q("button", {
                class: F(["pagination__item", {
                  "pagination__item--active": l === o.value
                }]),
                tabindex: "-1",
                onClick: () => E(l)
              }, " Dot #" + M(l), 11, he)
            ]))), 128))
          ])
        ])
      ], 2);
    };
  }
});
const me = ["id"], pe = { key: 0 }, be = /* @__PURE__ */ ee({
  __name: "SliderElement",
  props: {
    sliderId: null,
    index: null,
    class: null,
    debug: { type: Boolean }
  },
  setup(W) {
    const m = W, u = ae(m.sliderId), t = v(0), d = v(0), o = v(0), b = B(() => {
      var r;
      return ((r = u == null ? void 0 : u.value) != null ? r : 0) + 1;
    }), i = v(), h = v(0), w = v(0);
    let k = null;
    function z() {
      var _, y, x, S, L;
      const r = document.querySelector(
        `#${m.sliderId}.c-slider__track`
      );
      t.value = (_ = r == null ? void 0 : r.clientWidth) != null ? _ : 0, d.value = (x = (y = r == null ? void 0 : r.getBoundingClientRect()) == null ? void 0 : y.left) != null ? x : 0, o.value = (L = (S = r == null ? void 0 : r.getBoundingClientRect()) == null ? void 0 : S.left) != null ? L : 0;
    }
    te(() => {
      var _, y, x, S, L, X;
      const r = document.querySelector(
        `#${m.sliderId}.c-slider__track`
      );
      t.value = (_ = r == null ? void 0 : r.clientWidth) != null ? _ : 0, d.value = (x = (y = r == null ? void 0 : r.getBoundingClientRect()) == null ? void 0 : y.left) != null ? x : 0, o.value = (L = (S = r == null ? void 0 : r.getBoundingClientRect()) == null ? void 0 : S.left) != null ? L : 0, window.addEventListener("resize", z), m.debug && (console.log("Track bounding client rect:", r == null ? void 0 : r.getBoundingClientRect()), console.log("Element bound client rect:", (X = i == null ? void 0 : i.value) == null ? void 0 : X.getBoundingClientRect())), k = setInterval(() => {
        var D, V;
        !i.value || (h.value = (D = i.value.getBoundingClientRect()) == null ? void 0 : D.left, w.value = (V = i.value.getBoundingClientRect()) == null ? void 0 : V.right);
      });
    }), ce(() => {
      k && clearInterval(k), window.removeEventListener("resize", z);
    });
    const p = B(() => T());
    function T() {
      const r = h.value - d.value + 1 >= 0 && h.value - d.value + 1 < t.value, _ = w.value - o.value <= t.value && w.value > d.value;
      return !!(r || _);
    }
    return (r, _) => {
      var y;
      return $(), R("li", {
        ref_key: "elementRef",
        ref: i,
        class: F(["c-slider-element", {
          "c-slider-element--active": A(u) === m.index,
          "c-slider-element--next": A(b) === m.index,
          "c-slider-element--visible": A(p),
          [(y = m.class) != null ? y : ""]: !0
        }]),
        style: { "max-height": "100%" },
        id: `slide-${m.index}`
      }, [
        m.debug ? ($(), R("p", pe, [
          q("p", null, " Track: " + M(t.value) + " - " + M(d.value) + " - " + M(o.value), 1),
          q("p", null, " Element: " + M(h.value) + " - " + M(w.value), 1)
        ])) : G("", !0),
        H(r.$slots, "default")
      ], 10, me);
    };
  }
});
export {
  be as SliderElement,
  ye as SliderTrack
};
